import React from 'react';
import { HiOutlineX } from 'react-icons/hi';

const PainelSecaoExterna = ({ externaFeedback, sectionStyle, onFechar }) => {
  const { error, url, texto } = externaFeedback;
  const status = error == null || error === '' ? 'success' : 'error';

  return (
    <div className="briefing-ai-page__panel-section" style={sectionStyle}>
      <div className="briefing-ai-page__panel-section-head">
        <h2 className="briefing-ai-page__response-title">API externa</h2>
        <button
          type="button"
          className="briefing-ai-page__panel-section-close"
          onClick={onFechar}
          aria-label="Limpar e fechar retorno da API externa"
          title="Limpar API externa"
        >
          <HiOutlineX size={18} aria-hidden />
        </button>
      </div>
      {url ? (
        <p className="briefing-ai-page__external-url-wrap">
          <a
            href={url}
            target="_blank"
            rel="noopener noreferrer"
            className="briefing-ai-page__external-url"
          >
            {url}
          </a>
        </p>
      ) : null}
      <div
        className={
          status === 'success'
            ? 'briefing-ai-page__response-box briefing-ai-page__response-box--external-ok'
            : 'briefing-ai-page__response-box briefing-ai-page__response-box--external-erro'
        }
      >
        {status === 'success' ? (
          <pre className="briefing-ai-page__response-box-pre">{texto}</pre>
        ) : (
          error ?? texto ?? ''
        )}
      </div>
    </div>
  );
};

export default PainelSecaoExterna;
